import { useEffect, useState } from 'react';

import { t } from 'i18next';
import classnames from 'classnames';

import { useGetGradeDataQuery } from '@school_ify/schoolify-repository/src/teacher/types';

import { useAppDispatch, useAppSelector } from 'redux/hooks';
import useRouterHelper from 'hooks/useRouterHelper';
import { getSubjectsThunk, studySubjectsState } from 'redux/study/studySubjects.slice';
import PeriodsTable from 'views/Grades/PeriodsTable/PeriodsTable';
import { getUser } from 'redux/authentication/auth.slice';
import UpcomingProvider from 'application/dashboard/upcomings/upcoming.context';

import { IGradesQueryInterface } from './components/GradesQueryInterface';
import FilterBar from './components/FilterBar/FilterBar';

import './Grades.scoped.scss';

const Grades: React.FC = () => {
  const { query, routePush } = useRouterHelper<IGradesQueryInterface>();
  const dispatch = useAppDispatch();
  const user = useAppSelector(getUser);
  const subjectsList = useAppSelector(studySubjectsState);
  const [grades, setGrades] = useState([]);
  const gradeData = useGetGradeDataQuery();
  const classIdList = query.Class ? (query.Class as string).split(',') : [];
  const subjectIdList = query.Subjects ? (query.Subjects as string).split(',') : [];

  const handleClassChange = str => () => {
    routePush({
      search: {
        selected_subject: str,
      },
    });
  };

  const refetchGrades = () => {
    if (!query.Subjects || !query.selected_subject) {
      return;
    }
    gradeData.refetch({
      subject: (query.Subjects as string).split(','), // value for 'subject'
      // @ts-ignore
      class_id: query.selected_subject, // value for 'class_id'
    });
  };

  const getClassTitle = id => {
    const entity = subjectsList.subjects.find(entry => entry.teaching_structure.parent.id === id);

    if (entity) {
      return entity.teaching_structure.parent.title;
    }

    return null;
  };

  useEffect(() => {
    dispatch(getSubjectsThunk(user.id));
  }, []);

  useEffect(() => {
    refetchGrades();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [query]);

  useEffect(() => {
    // gorup items by date
    if (!gradeData) {
      return;
    }
    if (gradeData.loading) {
      return;
    }
    if (!gradeData.data) {
      return;
    }

    if (grades === gradeData.data.view_grades_by_subjects_and_classes) {
      return;
    }

    setGrades(gradeData.data.view_grades_by_subjects_and_classes);
  }, [gradeData]);

  if (subjectsList.subjects_loading !== 'success') {
    return null;
  }

  return (
    <UpcomingProvider>
      <FilterBar />
      <div className="grades-container">
        <div className="classes-menu">
          <div className="title">{t('grades:class')}:</div>

          {classIdList.map(id => {
            return (
              <div
                key={id}
                className={classnames({
                  item: true,
                  active: query.selected_subject === id,
                })}
                onClick={handleClassChange(id)}
              >
                <span>{getClassTitle(id)}</span>
              </div>
            );
          })}
        </div>

        <div key={'content_table_container'} className="card-body-wrapper">
          {grades &&
            query.Class &&
            subjectIdList.map(id => {
              return (
                <PeriodsTable
                  key={id}
                  subject={subjectsList.subjects.find(
                    ({ subject_id: subjectId }) => subjectId === id
                  )}
                  grades={grades.filter(obj => {
                    return obj.subject === id;
                  })}
                  onGradesUpdate={refetchGrades}
                />
              );
            })}
        </div>
      </div>
    </UpcomingProvider>
  );
};

export default Grades;
